<div class="merge-container">
  <!-- Header -->
  <div class="header">
    <div class="header-inner">
      <button mat-icon-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-content">
        <h1>Merge Referral with Patient Record</h1>
        @if (existingPatient()) {
          <span class="patient-badge">
            <mat-icon>person</mat-icon>
            {{ patientName() }} (Profile #{{ profileIdDisplay() }})
          </span>
        }
      </div>
      <!-- Legend -->
      <div class="legend">
        <div class="legend-item">
          <span class="legend-badge add">ADD</span>
          <span>New items from referral</span>
        </div>
        <div class="legend-item">
          <span class="legend-badge exists">EXISTS</span>
          <span>Already in patient record</span>
        </div>
        <div class="legend-item">
          <span class="legend-badge remove">REMOVE</span>
          <span>Items to remove from patient</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Loading referral and patient data...</p>
    </div>
  }

  <!-- Error State -->
  @if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-button (click)="goBack()">Go Back</button>
    </div>
  }

  <!-- Main Content -->
  @if (!isLoading() && !error() && referral() && existingPatient()) {
    <div class="content">
      <!-- Clinical Data Merge Sections -->
      @if (hasAnyData()) {
        <div class="sections-grid">
          @if (existingAllergyItems().length > 0 || referralAllergyItems().length > 0) {
            <xm-clinical-data-merge-section
              title="Allergies"
              icon="warning"
              iconColor="warn"
              itemLabel="allergies"
              [existingItems]="existingAllergyItems()"
              [referralItems]="referralAllergyItems()"
              [existingItemIds]="existingAllergyIds()"
              [itemsToAdd]="allergiesToAdd()"
              [itemsToRemove]="allergiesToRemove()"
              (selectionChange)="onAllergySelectionChange($event)">
            </xm-clinical-data-merge-section>
          }

          @if (existingMedicationItems().length > 0 || referralMedicationItems().length > 0) {
            <xm-clinical-data-merge-section
              title="Medications"
              icon="medication"
              iconColor="primary"
              itemLabel="medications"
              [existingItems]="existingMedicationItems()"
              [referralItems]="referralMedicationItems()"
              [existingItemIds]="existingMedicationIds()"
              [itemsToAdd]="medicationsToAdd()"
              [itemsToRemove]="medicationsToRemove()"
              (selectionChange)="onMedicationSelectionChange($event)">
            </xm-clinical-data-merge-section>
          }

          @if (existingProblemItems().length > 0 || referralProblemItems().length > 0) {
            <xm-clinical-data-merge-section
              title="Problems"
              icon="healing"
              iconColor="accent"
              itemLabel="problems"
              [existingItems]="existingProblemItems()"
              [referralItems]="referralProblemItems()"
              [existingItemIds]="existingProblemIds()"
              [itemsToAdd]="problemsToAdd()"
              [itemsToRemove]="problemsToRemove()"
              (selectionChange)="onProblemSelectionChange($event)">
            </xm-clinical-data-merge-section>
          }

          @if (existingDiagnosisItems().length > 0 || referralDiagnosisItems().length > 0) {
            <xm-clinical-data-merge-section
              title="Diagnosis Codes"
              icon="local_hospital"
              iconColor="primary"
              itemLabel="diagnosis codes"
              [existingItems]="existingDiagnosisItems()"
              [referralItems]="referralDiagnosisItems()"
              [existingItemIds]="existingDiagnosisIds()"
              [itemsToAdd]="diagnosisToAdd()"
              [itemsToRemove]="diagnosisToRemove()"
              (selectionChange)="onDiagnosisSelectionChange($event)">
            </xm-clinical-data-merge-section>
          }
        </div>
      } @else {
        <mat-card class="no-data-card">
          <mat-card-content>
            <mat-icon>info_outline</mat-icon>
            <p>No clinical data to merge. The referral will be accepted without any data changes.</p>
          </mat-card-content>
        </mat-card>
      }

    </div>

    <!-- Fixed Action Bar -->
    <div class="action-bar" [class.scrolled]="isScrolled()">
      <div class="action-bar-inner">
        <button mat-stroked-button (click)="goBack()">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          class="accept-button"
          [disabled]="isSubmitting()"
          (click)="acceptAndMerge()">
          @if (isSubmitting()) {
            <mat-spinner diameter="20"></mat-spinner>
            <span>Processing...</span>
          } @else {
            <mat-icon>merge</mat-icon>
            <span>Accept Referral</span>
          }
        </button>
      </div>
    </div>
  }
</div>
